<!--
页面二维码
20220331
-->
<template>
  <van-popup
    v-model="showPageQr"
    position="bottom"
    class="subplate_pageqr"
  >
    <div class="subplate_box">
      <div>
        <vue-qr
          :text="$store.state.siteUrl + $route.fullPath.replace(/(\?|&)_t=\d+$/, '')"
          :size="250"
          :margin="20"
          :dotScale="1"
          :logoSrc="'/static/img/logo_bs.png'"
          :colorDark="'#333'"
          :correctLevel="3"
          :logoScale="0.3">
        </vue-qr>
        <div>本页二维码</div>
      </div>

      <hr v-if="!$store.state.browser.bdminiprogram">

      <div v-if="!$store.state.browser.bdminiprogram">
        <img src="/static/img/qrcode_wxapp.png">
        <div>「积木小站」小程序</div>
      </div>

    </div>

  </van-popup>

</template>

<script>
import vueQr from 'vue-qr'

export default {
  name: 'PageQr',
  components: {
    vueQr,
  },
  props: {

  },
  data () {
    return {
      showPageQr: false,
    }
  },
  computed: {

  },
  watch: {},
  created() {
    const _this = this;

  },
  mounted() {

  },
  destroyed() {},
  methods: {

    //关闭面板
    hideSubplatePageQr(hide=true){
      const _this = this;
      _this.showPageQr = !hide;
    },

  }
}
</script>



<style lang="less">


</style>


<style lang="less" scoped>


/** 本页二维码 **/
.subplate_pageqr {
  z-index: 2002;
  width: 300px;
  top: 50%;
  bottom: auto;
  left: 50%;
  margin: -300px auto auto -150px;
  text-align: center;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 0 30px rgba(0,0,0,.5);
  .subplate_box {
    img {
      width: 200px;
      height: 200px;
    }
    div {
      padding: 10px;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PageQr.vue